<template>
    <div class="col-sm-5">
        <div class="card">
            <div class="card-body">
                <div class="col mt-0">
                    <h5 class="card-title">Transactions</h5>
                </div>
                <b-tabs content-class="mt-3">
                    <b-tab title="Open Bids (Actual)" active>
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.open_bids"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Canceled Bids (Monthly)">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.canceled_bids"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Total Bids Applications (Monthly)">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.total_bids"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Total Artist applied (Monthly)">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.total_artist_applied"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Transactions">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.transactions"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Cash of transactions">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.cash_of_transactions"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                    <b-tab title="Month-Over-Month Growth (Transaction Count)">
                        <b-table class="table-responsive"
                            responsive="lg"
                            :items="transactions.transactions_count_growth"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        ></b-table>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransactionsTable',
    props: ['transactions'],
    data: () => ({
        fields: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'],
        sortBy: 'January',
        sortDesc: false,
    }),
    methods: {
        getFieldsArray(month) {
            this.fields.length = month + 1
        }
    },
    created() {
        let data = new Date()
        let month = data.getMonth()
        this.getFieldsArray(month)
    }
}
</script>
